

export const TikTokIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff';
    }

    return (
        <svg
            fill={color ? color : '#fff'}
            width="24px"
            height="24px"
            viewBox="0 0 256 256"
            id="Flat"
            xmlns="http://www.w3.org/2000/svg"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <path d="M232,84v40a7.99977,7.99977,0,0,1-8,8,103.32406,103.32406,0,0,1-48.00049-11.70752L176,156A76,76,0,1,1,86.59766,81.17971,7.99952,7.99952,0,0,1,96,89.05569l-.00049,41.63916a7.99971,7.99971,0,0,1-4.56689,7.22607A20.00272,20.00272,0,1,0,120,156V28a7.99977,7.99977,0,0,1,8-8h40a7.99977,7.99977,0,0,1,8,8,48.05436,48.05436,0,0,0,48,48A7.99977,7.99977,0,0,1,232,84Z" />
        </svg>
    );
}

export const TikTokWhiteIcon = (props) => {
    return (
        <svg
            fill="#fff"
            width="24px"
            height="24px"
            viewBox="0 0 256 256"
            id="Flat"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M232,84v40a7.99977,7.99977,0,0,1-8,8,103.32406,103.32406,0,0,1-48.00049-11.70752L176,156A76,76,0,1,1,86.59766,81.17971,7.99952,7.99952,0,0,1,96,89.05569l-.00049,41.63916a7.99971,7.99971,0,0,1-4.56689,7.22607A20.00272,20.00272,0,1,0,120,156V28a7.99977,7.99977,0,0,1,8-8h40a7.99977,7.99977,0,0,1,8,8,48.05436,48.05436,0,0,0,48,48A7.99977,7.99977,0,0,1,232,84Z" />
        </svg>
    );
}

export const TikTokBlueIcon = (props) => {
    return (
        <svg
            fill="#166fe5"
            width="24px"
            height="24px"
            viewBox="0 0 256 256"
            id="Flat"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M232,84v40a7.99977,7.99977,0,0,1-8,8,103.32406,103.32406,0,0,1-48.00049-11.70752L176,156A76,76,0,1,1,86.59766,81.17971,7.99952,7.99952,0,0,1,96,89.05569l-.00049,41.63916a7.99971,7.99971,0,0,1-4.56689,7.22607A20.00272,20.00272,0,1,0,120,156V28a7.99977,7.99977,0,0,1,8-8h40a7.99977,7.99977,0,0,1,8,8,48.05436,48.05436,0,0,0,48,48A7.99977,7.99977,0,0,1,232,84Z" />
        </svg>
    );
}

export const GoogleIcon = (props) => {
    return (
        <svg
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            data-name="Layer 1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M23.75,16A7.7446,7.7446,0,0,1,8.7177,18.6259L4.2849,22.1721A13.244,13.244,0,0,0,29.25,16" fill="#00ac47" />
            <path d="M23.75,16a7.7387,7.7387,0,0,1-3.2516,6.2987l4.3824,3.5059A13.2042,13.2042,0,0,0,29.25,16" fill="#4285f4" />
            <path d="M8.25,16a7.698,7.698,0,0,1,.4677-2.6259L4.2849,9.8279a13.177,13.177,0,0,0,0,12.3442l4.4328-3.5462A7.698,7.698,0,0,1,8.25,16Z" fill="#ffba00" />
            <polygon fill="#2ab2db" points="8.718 13.374 8.718 13.374 8.718 13.374 8.718 13.374" />
            <path d="M16,8.25a7.699,7.699,0,0,1,4.558,1.4958l4.06-3.7893A13.2152,13.2152,0,0,0,4.2849,9.8279l4.4328,3.5462A7.756,7.756,0,0,1,16,8.25Z" fill="#ea4435" />
            <polygon fill="#2ab2db" points="8.718 18.626 8.718 18.626 8.718 18.626 8.718 18.626" />
            <path d="M29.25,15v1L27,19.5H16.5V14H28.25A1,1,0,0,1,29.25,15Z" fill="#4285f4" />
        </svg>
    );
}

export const TwitchIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff';
    }

    return (
        <svg
            // style={{
            //     filter: "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%) !important"
            // }}
            width="24px"
            height="24px"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 0C0.223858 0 0 0.223858 0 0.5V11.5C0 11.7761 0.223858 12 0.5 12H2.5V14.5C2.5 14.6953 2.61367 14.8727 2.79107 14.9543C2.96847 15.0358 3.17714 15.0067 3.3254 14.8796L6.68496 12H11.5C11.6326 12 11.7598 11.9473 11.8536 11.8536L14.8536 8.85355C14.9473 8.75979 15 8.63261 15 8.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM10 8V3H11V8H10ZM7 3V8H8V3H7Z"
                fill={color ? color : '#fff'}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            />
        </svg>
    );
}

export const TwitchWhiteIcon = (props) => {
    return (
        <svg
            // style={{
            //     filter: "invert(29%) sepia(88%) saturate(2537%) hue-rotate(206deg) brightness(93%) contrast(90%)"
            // }}
            width="24px"
            height="24px"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 0C0.223858 0 0 0.223858 0 0.5V11.5C0 11.7761 0.223858 12 0.5 12H2.5V14.5C2.5 14.6953 2.61367 14.8727 2.79107 14.9543C2.96847 15.0358 3.17714 15.0067 3.3254 14.8796L6.68496 12H11.5C11.6326 12 11.7598 11.9473 11.8536 11.8536L14.8536 8.85355C14.9473 8.75979 15 8.63261 15 8.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM10 8V3H11V8H10ZM7 3V8H8V3H7Z"
                fill="#fff"
            />
        </svg>
    );
}

export const TwitchBlueIcon = (props) => {
    return (
        <svg
            // style={{
            //     filter: "invert(29%) sepia(88%) saturate(2537%) hue-rotate(206deg) brightness(93%) contrast(90%)"
            // }}
            width="24px"
            height="24px"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 0C0.223858 0 0 0.223858 0 0.5V11.5C0 11.7761 0.223858 12 0.5 12H2.5V14.5C2.5 14.6953 2.61367 14.8727 2.79107 14.9543C2.96847 15.0358 3.17714 15.0067 3.3254 14.8796L6.68496 12H11.5C11.6326 12 11.7598 11.9473 11.8536 11.8536L14.8536 8.85355C14.9473 8.75979 15 8.63261 15 8.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM10 8V3H11V8H10ZM7 3V8H8V3H7Z"
                fill="#166fe5"
            />
        </svg>
    );
}

export const SignalIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff'
    }

    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            fill={color ? color : '#fff'}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <title>Signal icon</title>
            <path d="M12.012 2.598c-5.22 0-9.452 3.9-9.452 8.709 0 3.016 1.219 5.301 3.155 6.774H5.71l.234 3.042v.004c0 .017 0 .031.004.046v.006c.024.144.15.255.301.255.053 0 .1-.015.144-.035l.011-.008L9.3 19.717c.854.196 1.767.299 2.71.299 5.22 0 9.452-3.899 9.452-8.71 0-4.81-4.233-8.709-9.454-8.709l.004.001zM10.39.72c.525-.065 1.061-.104 1.605-.104.38 0 .75.02 1.119.052l.057-.614C12.781.019 12.392 0 11.997 0c-.57 0-1.135.036-1.691.109l.083.612.001-.001zm3.797.094c.915.165 1.785.436 2.61.795l.252-.567c-.132-.056-.263-.112-.397-.165-.762-.3-1.551-.524-2.355-.671l-.11.608zm9.169 10.556c-.015.915-.155 1.806-.405 2.655l.59.175c.267-.903.416-1.854.431-2.831l-.616.001zM6.745 1.814c.811-.389 1.678-.698 2.586-.902L9.196.308c-.631.141-1.251.329-1.853.569-.297.117-.586.245-.867.381l.269.556zm13.65 1.399c-.706-.649-1.485-1.207-2.329-1.673l-.311.541c.811.445 1.561.981 2.224 1.596l.416-.462v-.002zm-5.244 18.838c.945-.24 1.845-.591 2.686-1.03l-.315-.533c-.786.413-1.631.738-2.521.967l.15.596zM3.677 4.005c.63-.638 1.347-1.2 2.13-1.675l-.327-.529c-.698.422-1.35.914-1.945 1.473-.102.094-.2.191-.3.289l.439.441.003.001zm19.48 11.28l-.568-.236c-.349.833-.803 1.614-1.354 2.332l.495.369c.577-.758 1.061-1.586 1.424-2.465h.003zM20.726 4.433c.606.675 1.122 1.425 1.534 2.228l.555-.275c-.435-.852-.979-1.645-1.627-2.366l-.465.413h.003zm2.554 3.003l-.568.244c.313.828.521 1.703.604 2.61l.615-.061c-.088-.956-.305-1.892-.651-2.793zM6.386 22.849l-.969.425-.332-1.025-.585.19.438 1.347c.029.083.09.151.167.188.041.017.083.026.126.026s.084-.009.123-.026l1.283-.563-.251-.562zm3.823-1.193c-.078-.016-.157-.027-.237-.041l-.465-.079c-.061-.009-.12 0-.172.023l-1.951.853.271.554 1.845-.803c.125.021.25.041.371.059.068.017.139.026.209.038l.129-.604zm3.728.02c-.633.104-1.281.156-1.942.156-.273 0-.525-.015-.772-.038l-.019.615c.251.024.511.04.791.04.698 0 1.383-.058 2.048-.166l-.104-.606-.002-.001zM1.517 7.116c.37-.825.852-1.598 1.425-2.302l-.47-.407c-.61.745-1.116 1.557-1.508 2.427l-.01.021.563.261zM20.532 18.21c-.612.651-1.31 1.229-2.07 1.728l.339.515c.806-.524 1.541-1.14 2.19-1.829l-.459-.414zM.97 14.551c-.188-.796-.293-1.676-.323-2.671H.031c.03 1.071.145 2.005.345 2.843l.594-.172zM.538 7.925c-.297.91-.468 1.853-.51 2.813l.615.03c.042-.923.209-1.816.487-2.662l-.592-.181zm4.199 13.26l-.59-1.815c-.02-.06-.056-.109-.105-.147-.232-.182-.449-.366-.66-.558l-.422.446c.194.184.408.362.629.541l.561 1.717.587-.184zm-2.105-3.292c-.591-.691-1.037-1.449-1.355-2.315l-.573.229c.041.107.083.216.126.322.33.796.771 1.509 1.342 2.175l.46-.411z" />
        </svg>
    );
}

export const WeChatIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff'
    }

    return (
        <svg width="24px"
            height="24px"
            viewBox="0 0 24 24"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            fill={color ? color : '#fff'}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <title>WeChat icon</title>
            <path d="M23.541 12.748c-.609-1.38-1.758-2.476-3.092-3.151-2.354-1.192-5.281-1.185-7.629.03-1.631.837-2.993 2.337-3.379 4.162-.318 1.344-.033 2.791.68 3.961 1.061 1.762 2.979 2.887 4.971 3.248 1.443.293 2.936.119 4.338-.285.842.326 1.592.854 2.408 1.246-.211-.707-.436-1.406-.676-2.102.916-.65 1.746-1.461 2.244-2.479.744-1.415.789-3.171.135-4.63zm-9.924-9.466c-2.495-1.404-5.602-1.615-8.286-.645-1.764.635-3.36 1.815-4.346 3.42-.895 1.45-1.23 3.258-.799 4.917.433 1.84 1.711 3.383 3.262 4.413-.3.85-.585 1.699-.855 2.555.975-.51 1.95-1.043 2.926-1.561 1.17.375 2.415.559 3.66.518-.33-.943-.405-1.965-.255-2.951.225-1.371.975-2.625 1.994-3.554 1.726-1.615 4.171-2.296 6.496-2.131-.436-2.135-1.936-3.939-3.824-4.98h.027zm1.733 9.989c-.209.652-1.156.848-1.615.352-.506-.459-.309-1.418.355-1.623.734-.31 1.582.537 1.26 1.271zm4.795.092c-.256.586-1.141.723-1.576.27-.209-.191-.27-.479-.344-.73.104-.458.42-.933.93-.955.705-.098 1.336.773.975 1.416h.015zM12.99 6.909c.008.961-1.275 1.561-1.995.909-.747-.535-.535-1.837.342-2.106.785-.315 1.713.344 1.651 1.185l.002.012zm-6.059.244c-.172.835-1.291 1.238-1.946.678-.759-.535-.546-1.861.345-2.131.873-.336 1.865.55 1.601 1.453z" />
        </svg>
    );
}

export const DiscordIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff'
    }

    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            fill={color ? color : '#fff'}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
        </svg>
    );
}

export const TinderIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff'
    }

    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            fill={color ? color : '#fff'}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <title>Tinder icon</title>
            <path d="M9.317 9.451c.045.073.123.12.212.12.06 0 .116-.021.158-.057l.015-.012c.39-.325.741-.66 1.071-1.017 3.209-3.483 1.335-7.759 1.32-7.799-.09-.21-.03-.459.15-.594.195-.135.435-.12.615.033 10.875 10.114 7.995 17.818 7.785 18.337-.87 3.141-4.335 5.414-8.444 5.53-.138.008-.242.008-.363.008-4.852 0-8.977-2.989-8.977-6.807v-.06c0-5.297 4.795-10.522 5.009-10.744.136-.149.345-.195.525-.105.18.076.297.255.291.451-.043 1.036.167 1.935.631 2.7v.015l.002.001z" />
        </svg>
    );
}

export const SnapchatIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff'
    }

    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 15 15"
            xmlns="http://www.w3.org/2000/svg"
            fill={color ? color : '#fff'}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <path d="M7.5 0C6.24898 0 5.14443 0.475716 4.36453 1.47856C3.66908 2.37213 3.27515 4.19057 3.20982 5.70842L3.13065 5.72056L3.10755 5.72414C2.99077 5.74199 2.85156 5.76342 2.70838 5.79199C2.20427 5.89485 1.25016 6.16842 1.03637 7.26626C0.936082 7.77912 1.04892 8.22699 1.30427 8.57413C1.53322 8.88412 1.84333 9.06911 2.07163 9.18482C2.16921 9.23322 2.26801 9.27872 2.36789 9.32126C2.14026 9.99411 1.74107 10.687 1.29899 11.3141C0.885283 11.9012 0.994817 12.6448 1.2086 13.1298C1.42238 13.6155 1.82632 13.5936 2.5 13.625C2.88204 13.6429 3.28255 13.685 3.68108 13.7636C3.86121 13.7993 4.07367 13.8779 4.3376 13.9957C4.49116 14.0651 4.64381 14.1367 4.79551 14.2107C4.9189 14.2707 5.0502 14.3336 5.2013 14.4036C5.82153 14.6922 6.58362 15 7.42819 15C8.27276 15 9.03485 14.6922 9.65508 14.4036C9.80618 14.3336 9.93682 14.2707 10.0609 14.2107L10.0884 14.1974C10.2338 14.1274 10.3704 14.0616 10.5188 13.9957C10.7827 13.8779 10.9952 13.8 11.1753 13.7643C11.5738 13.6857 11.9743 13.6429 12.3557 13.625C13.03 13.5936 13.5532 13.6155 13.7676 13.1298C13.9814 12.6448 14.0909 11.9012 13.6772 11.3141C13.2378 10.6913 12.8406 10.0034 12.6123 9.33482C12.7099 9.2941 12.826 9.24554 12.9422 9.1884C13.1764 9.07483 13.5037 8.88696 13.7326 8.56196C13.9985 8.18482 14.0744 7.70912 13.9227 7.19555C13.6198 6.17342 12.7403 5.90057 12.225 5.79271C12.0857 5.76343 11.9518 5.742 11.8396 5.72486L11.8264 5.72272L11.7657 5.71271C11.6958 4.28915 11.323 2.48785 10.6434 1.58071C9.87799 0.560005 8.78005 0 7.5 0Z" />
        </svg>
    );
}

export const PatreonIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff'
    }

    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 15 15"
            xmlns="http://www.w3.org/2000/svg"
            fill={color ? color : '#fff'}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <path d="M3 0H0V15H3V0Z" />
            <path d="M9.5 0C6.46243 0 4 2.46243 4 5.5C4 8.53757 6.46243 11 9.5 11C12.5376 11 15 8.53757 15 5.5C15 2.46243 12.5376 0 9.5 0Z" />
        </svg>
    );
}

export const VkontakteIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff'
    }

    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 1024 1024"
            fill={color ? color : '#fff'}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <path d="M3 248c0-38 26-53 58-55l149 1c9 0 17 6 20 15 34 110 76 178 126 255 3 6 8 9 13 9 4 0 8-2 11-7l3-11 1-173c0-25-12-29-40-33-11-2-18-12-18-22 0-2 0-4 1-6 14-43 58-65 120-65l56-1c46 0 88 20 88 79v227c4 3 8 5 13 5 8 0 18-5 26-18 52-73 111-160 119-206 0-2 1-3 2-5 11-22 39-37 51-41 2-1 5-2 9-2h155l10 1c15 0 26 10 31 19 9 14 7 29 8 35v7c-15 91-119 193-163 259-6 8-9 15-9 22 0 6 3 12 8 18l146 184c8 11 12 24 12 35 0 33-31 52-61 55l-17 1H779c-3 0-5 1-8 1-17 0-31-9-41-19-32-39-63-79-94-118-6-8-8-9-14-13-7 29-13 59-20 89l-3 17c-5 18-18 37-42 42l-14 1h-98C272 830 117 584 8 277c-3-8-5-19-5-29zm601 259c-26 0-55-15-55-43V234c0-27-12-37-45-37l-57 2c-32 0-50 5-65 15 23 11 44 26 44 68v176c-3 35-32 58-60 58-19 0-36-11-46-29-45-68-83-132-116-224l-9-26-133-1c-18 0-16 1-16 10 0 6 1 14 2 19l21 56c109 282 246 467 376 467h100c14 0 13-17 16-27l19-88c4-9 7-17 14-24 8-8 17-11 26-11 19 0 37 15 49 29l85 108c7 11 13 13 17 13h165c16 0 30-5 30-15 0-3-1-7-3-10L818 582c-12-15-17-30-17-45 0-16 6-32 16-46 42-63 132-153 153-227l3-13c-1-5-1-9-2-14H814c-10 4-18 10-24 18l-6 19c-23 64-86 152-131 213-15 14-32 20-49 20z" />
        </svg>
    );
}

export const OnlyfansIcon = ({ color }) => {
    const handleMouseEnter = e => {
        // e.target.style.filter = "invert(33%) sepia(78%) saturate(3299%) hue-rotate(205deg) brightness(94%) contrast(91%)";
        e.target.style.fill = color ? color : '#166fe5'
    }
    const handleMouseLeave = e => {
        // e.target.style.filter = "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7476%) hue-rotate(110deg) brightness(98%) contrast(108%)";
        e.target.style.fill = color ? color : '#fff'
    }

    return (
        <svg
            viewBox="-20.62 0.53 820.42 555.49"
            xmlns="http://www.w3.org/2000/svg"
            width="24" height="24"
            fill={color ? color : '#fff'}
        >
            <path d="M266.82.53c35 0 69.65 6.91 101.98 20.34s61.71 33.11 86.45 57.93c24.75 24.81 44.37 54.27 57.77 86.7a267.919 267.919 0 0 1 20.29 102.27c0 108.09-64.93 205.53-164.51 246.89s-214.2 18.5-290.41-57.93C2.18 380.3-20.62 265.36 20.62 165.5 61.87 65.64 159.04.53 266.82.53zm0 347.4c10.5.01 20.9-2.05 30.61-6.07s18.52-9.93 25.95-17.38 13.31-16.29 17.33-26.02a80.365 80.365 0 0 0 6.06-30.7c0-32.43-19.48-61.66-49.35-74.07s-64.26-5.55-87.12 17.38-29.7 57.41-17.33 87.37 41.53 49.49 73.86 49.49z"
                />
            <path d="M566.35 200.96c67.71 19.54 147.63 0 147.63 0-23.19 101.55-96.75 165.15-202.81 172.89a266.766 266.766 0 0 1-40.48 65.86 266.208 266.208 0 0 1-57.62 51.43c-21.6 14.24-45.15 25.25-69.92 32.68s-50.48 11.19-76.33 11.18l79.95-254.81C428.95 18.28 471.08.54 665.98.54H799.8c-22.38 98.88-99.54 174.41-233.44 200.42z"
                />
        </svg>
    );
}